const MAX_BG_SIZE = 2000;

/**
 * This places a large background image behind the tiled image to improve the apparent performance as the user pans or
 * zooms over areas that haven't yet been fetched.
 * @param viewport
 * @constructor
 */
export function ViewportBackgroundLayer (viewport) {
  const container = document.createElement('div');

  let backgroundZoom;
  let width, height, img;

  // Expose the container so the renderer can reposition it
  this.container = container;

  // Auto initialize this class.
  (function init () {
    const imageDimensions = viewport.getImageDims();
    container.className = 'us-vp-bg-container';
    backgroundZoom = parseInt(Math.ceil(Math.max(imageDimensions.w, imageDimensions.h) / MAX_BG_SIZE), 10);
    width = parseInt(imageDimensions.w / backgroundZoom, 10);
    height = parseInt(imageDimensions.h / backgroundZoom, 10);

    img = new Image();
    img.src = viewport.urlBuilder.region(0, 0, width, height, backgroundZoom);
    container.appendChild(img);
  }());
}



// WEBPACK FOOTER //
// ./src/uScope/js/lib/services/rendering/ViewportBackgroundLayer.js